import {Offcanvas, OffcanvasActions, OffcanvasGravity} from "../../../../offcanvas/Offcanvas";
import Rosetta from "../../../../../rosetta/Rosetta";
import {useEffect, useState} from "react";
import {FileComponent} from "../../../common/FileComponent";
import {LoadingSpinner} from "../../../../loading/LoadingSpinner";
import Axios from "axios";
import {API, ENDPOINTS} from "../../../../../network/API";
import AlertModal from "../../../../alertmodal/AlertModal";
import {ProjectSelectionModal} from "../../../common/ProjectSelectionModal";
import WindowUtil from "../../../../../util/WindowUtil";
import {UrlUtil} from "../../../../../util/UrlUtil";
import Validator from "../../../../../util/Validator";
import {Toast} from "../../../../toast/TokyoToaster";

export const ProjectDocumentEditorModal = (props) => {

    const {shown} = props;
    const {documentID} = props;
    const {clientID} = props;
    const {sectionID} = props;
    const {callback} = props;

    const [document, setDocument] = useState(null);
    const [documentProject, setDocumentProject] = useState(null);
    const [documentTitle, setDocumentTitle] = useState("");
    const [documentDescription, setDocumentDescription] = useState("");
    const [documentType, setDocumentType] = useState(null);
    const [documentActive, setDocumentActive] = useState(1);
    const [documentFile, setDocumentFile] = useState(null);

    const [documentTypes, setDocumentTypes] = useState([]);

    const [callbackData, setCallbackData] = useState(null);

    const [documentNetworkInFlight, setDocumentNetworkInFlight] = useState(false);
    const [typeNetworkInFlight, setTypeNetworkInFlight] = useState(false);

    const [projectSelectionShown, setProjectSelectionShown] = useState(false);

    const [forceDismiss, setForceDismiss] = useState(false);

    useEffect(() => {
        if (shown) {
            WindowUtil.lockBodyScroll();

            if (documentID) {
                fetchDocumentFromNetwork();
            }
            fetchDocumentTypesFromNetwork();
        } else {
            WindowUtil.unlockBodyScroll();

            setDocument(null);
            setDocumentTitle("");
            setDocumentDescription("");
            setDocumentProject(null);
            setDocumentType(null);
            setDocumentActive(null);
            setDocumentFile(null);

            setForceDismiss(false);
        }
    }, [shown]);

    useEffect(() => {
        if (!projectSelectionShown) {
            if (shown) {
                WindowUtil.lockBodyScroll();
            }
        }
    }, [projectSelectionShown]);

    useEffect(() => {
        if (document) {
            setDocumentProject({ id : document.projectID, project_name : document.projectName })
            setDocumentTitle(document.title)
            setDocumentDescription(document.description)
            setDocumentType(document.documentTypeID)
            setDocumentActive(document.active)
        }
    }, [document]);

    function handleCallback(action) {
        if (callback) {
            callback(action, callbackData);
        }
    }

    function projectSelectionDidCallback(action, data) {
        if (action === OffcanvasActions.CLOSE) {
            if (data) {
                setDocumentProject(data);
            }
            setProjectSelectionShown(false);
        }
    }

    function fetchDocumentFromNetwork() {
        if (documentNetworkInFlight) return;
        setDocumentNetworkInFlight(true);

        let data = {
            ids : [documentID],
            sectionID
        };

        Axios.post(ENDPOINTS.project.getProjectDocumentsAdmin, data)
            .then((r) => {
                let error = null;

                const resp = API.parse(r);
                if (resp.success) {
                    if (resp.data.data.length > 0) {
                        setDocument(resp.data.data[0]);
                    } else {
                        error = "document_requests.document_editor_not_found";
                    }
                } else {
                    error = API.formatError(resp);
                }

                if (error !== null) {
                    AlertModal.showError(Rosetta.string(error));
                }

                setDocumentNetworkInFlight(false);
            })
            .catch((e) => {
                console.log(e);
                setDocumentNetworkInFlight(false);
                AlertModal.showError(Rosetta.string("common.error_common_unknown", { error_code : "PDE1000C" }));
            });
    }

    function fetchDocumentTypesFromNetwork() {
        if (typeNetworkInFlight) return;
        setTypeNetworkInFlight(true);

        Axios.post(ENDPOINTS.project.getProjectDocumentTypes, null)
            .then((r) => {
                const resp = API.parse(r);
                if (resp.success) {
                    setDocumentTypes(resp.data.data);
                } else {
                    AlertModal.showError(API.formatError(resp));
                }
                setTypeNetworkInFlight(false);
            })
            .catch((e) => {
                console.log(e);
                setTypeNetworkInFlight(false);
                AlertModal.showError(Rosetta.string("common.error_common_unknown", { error_code : "PDE1200C" }));
            })
    }

    function submitDocumentOverNetwork() {
        if (documentNetworkInFlight) return;

        console.log("Doc Type: " + documentType);

        const validationResult = Validator.validateCreateFormData({
            documentID, sectionID, documentTitle, documentDescription,
            projectID : (documentProject ? documentProject.id : undefined),
            documentType, documentActive
        }, [
            Validator.rule("documentID", "int", "", "id", true),
            Validator.rule("sectionID", "int", "", "projectDocumentSectionID", true),
            Validator.rule("documentType", "int", Rosetta.string("document_requests.document_editor_type"), "projectDocumentTypeID"),
            Validator.rule("projectID", "int", Rosetta.string("document_requests.document_editor_project"), "projectID"),
            Validator.rule("documentTitle", "string", Rosetta.string("document_requests.document_editor_doc_title"), "title"),
            Validator.rule("documentDescription", "string", Rosetta.string("document_requests.document_editor_description"), "description", true),
            Validator.rule("documentActive", "int", "", "active", true)
        ]);

        let errorMessage = null;

        if (!validationResult.success) {
            errorMessage = validationResult.error;
        } else if (!documentID && !documentFile) {
            console.log("VALIDATION ERROR - NO FILE");
            console.log(documentFile);
            errorMessage = Rosetta.string("validation.missing_property", { label : Rosetta.string("document_requests.document_editor_file")});
        }

        if (errorMessage) {
            AlertModal.showError(errorMessage);
            return;
        }

        setDocumentNetworkInFlight(true);

        const formData = validationResult.formData;

        if (documentFile) {
            formData.append("file", documentFile);
        }

        Axios.post(ENDPOINTS.project.submitProjectDocumentAdmin, formData)
            .then((r) => {
                const resp = API.parse(r);
                if (resp.success) {
                    Toast.show(
                        Rosetta.string("common.success"),
                        Rosetta.string("document_requests.document_editor_success"),
                        Toast.SUCCESS,
                        Toast.LONG
                    );
                    setCallbackData(resp.data.document);
                    setForceDismiss(true);
                } else {
                    AlertModal.showError(API.formatError(resp));
                }
                setDocumentNetworkInFlight(false);
            })
            .catch((e) => {
                console.log(e);
                setDocumentNetworkInFlight(false);
                AlertModal.showError(Rosetta.string("common.error_common_unknown", { error_code : "PDES3001C" }));
            });
    }

    // RENDER

    if (!shown) return [];

    let formActions = (<button className={"btn btn-primary"} onClick={() => submitDocumentOverNetwork()}>{Rosetta.string("common.save")}</button>);
    if (documentNetworkInFlight) {
        formActions = (
            <LoadingSpinner small={true} inline={true} />
        );
    }

    let existingFileCard = [];
    if (document && document.filePath) {
        existingFileCard = (
            <div className={"row mt-2"}>
                <div className={"col-12"}>
                    <label>{Rosetta.string("document_requests.document_editor_file")}</label>
                    <div className={"card"}>
                        <div className={"card-body"}>
                            <div className={"row"}>
                                <div className={"col-12"}>
                                    <strong>{Rosetta.string("document_requests.document_editor_version", { version : document.version })}</strong>
                                </div>
                            </div>

                            <div className={"row mt-2 align-items-center"}>
                                <div className={"col-md-8"}>
                                    {UrlUtil.getLastPathPart(document.filePath)}
                                </div>
                                <div className={"col-md-4 text-end"}>
                                    <a className={"btn btn-primary"} href={document.filePath} target={"_blank"} rel={"noreferrer"}>{Rosetta.string("common.view")}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <>
            <Offcanvas
                shown={true}
                gravity={OffcanvasGravity.END}
                title={Rosetta.string("document_requests.document_editor_title")}
                forceDismiss={forceDismiss}
                callback={handleCallback}>

                <div className={"row"}>
                    <div className={"col-12"}>
                        <label>{Rosetta.string("document_requests.document_editor_project")}</label>
                        <span className={"form-control clickable"} onClick={() => setProjectSelectionShown(true)}>{documentProject ? documentProject.project_name : Rosetta.string("common.please_select")}</span>
                    </div>
                </div>

                <div className={"row mt-2"}>
                    <div className={"col-12"}>
                        <label>{Rosetta.string("document_requests.document_editor_type")}</label>
                        <select className={"form-select"} value={documentType} onChange={(e) => setDocumentType(e.target.value)}>
                            <option value={"-1"}>{Rosetta.string("common.please_select")}</option>
                            {documentTypes.map((type) => (
                                <option value={type.id}>{type.title}</option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className={"row mt-2"}>
                    <div className={"col-12"}>
                        <label>{Rosetta.string("document_requests.document_editor_doc_title")}</label>
                        <input type={"text"} className={"form-control"} value={documentTitle} onChange={(e) => setDocumentTitle(e.target.value)} />
                    </div>
                </div>

                <div className={"row mt-2"}>
                    <div className={"col-12"}>
                        <label>{Rosetta.string("document_requests.document_editor_description")}</label>
                        <textarea className={"form-control"} value={documentDescription} onChange={(e) => setDocumentDescription(e.target.value)} />
                    </div>
                </div>

                {existingFileCard}

                <div className={"row mt-2"}>
                    <div className={"col-12"}>
                        <label>{Rosetta.string("document_requests.document_editor_file_new")}</label>
                        <FileComponent callback={setDocumentFile} />
                    </div>
                </div>

                <div className={"row mt-2"}>
                    <div className={"col-12"}>
                        <label>{Rosetta.string("document_requests.document_editor_active")}</label>
                        <select className={"form-select"} value={documentActive}>
                            <option value={"0"}>{Rosetta.string("common.no")}</option>
                            <option value={"1"}>{Rosetta.string("common.yes")}</option>
                        </select>
                    </div>
                </div>

                <div className={"row mt-2"}>
                    <div className={"col-12 text-center"}>
                        {formActions}
                    </div>
                </div>

            </Offcanvas>

            <ProjectSelectionModal
                shown={projectSelectionShown}
                callback={projectSelectionDidCallback} />
        </>
    )

}